import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, StarIcon } from 'lucide-react';
import { cn } from '@/lib/utils';
import { CTAButton, CHECKOUT_URL } from './CTAButton';
const plans = [{
  name: 'MegaPack Fiesta Épica',
  icon: '📘',
  ideal: 'Mamás y papás que quieren organizar el cumpleaños perfecto sin gastar de más',
  was: '$54.990 ARS',
  now: '$19.990 ARS',
  featured: false,
  features: ['12 Tomos completos', 'Cronograma Maestro listo', 'Presupuesto anti-inflación', 'Decoración DIY paso a paso', '5 Bonos estratégicos gratis', 'Garantía 7 días'],
  cta: 'Quiero el MegaPack'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Precios" className="bg-radial-glow" data-id="element-121" data-mp="20s3c9a6ebn70">
      <div className="mx-auto max-w-5xl px-5 pt-[0px] pb-[23px]" data-id="element-122" data-mp="3h74pkw9qcbf5">
        <div className="mt-10 grid place-items-center" data-id="element-123" data-mp="3h9hclnuchbz2">
          {plans.map((plan, i) => <motion.div key={plan.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className={cn('relative flex w-full max-w-md flex-col items-center rounded-3xl border px-7 pb-7 pt-8 text-center', plan.featured ? 'border-iris bg-ink-2 shadow-[0_20px_60px_-20px_rgba(124,92,245,0.55)]' : 'border-white/10 bg-ink-2')} data-id="element-124" data-mp="3cae8c5m6v9s5" data-mpi={i}>
              {plan.featured && <span className="absolute -top-3 left-1/2 inline-flex -translate-x-1/2 items-center gap-1 rounded-full bg-iris px-4 py-1 text-xs font-extrabold uppercase tracking-wide text-white" data-id="element-125" data-mp="3n6vaab5qd09i">
                  <StarIcon className="h-3.5 w-3.5 fill-current" data-id="element-126" data-mp="2uj9897c5i3or" /> Más completo
                </span>}

              <h3 className="font-display text-xl font-black text-white" data-id="element-127" data-mp="2zg9fvmonfehz">
                {plan.icon} {plan.name}
              </h3>
              <p className="mt-2 text-sm text-white/60" data-id="element-128" data-mp="2rerzq16tmmva">
                <span className="font-semibold text-white/80" data-id="element-129" data-mp="2mgqkxsgfh9pm">Ideal para:</span> {plan.ideal}
              </p>

              <div className="mt-6" data-id="element-130" data-mp="315czhry8dxfs">
                <span className="text-base font-medium text-white/40 line-through" data-id="element-131" data-mp="318iluzfh6l7t">{plan.was}</span>
                <div className="font-display text-4xl font-black text-white" data-id="element-132" data-mp="2w9xnz6np4dmj">{plan.now}</div>
                <p className="mt-1 text-xs font-semibold text-iris-soft" data-id="element-133" data-mp="28jttboshjo7o">
                  Pago único · Acceso de por vida
                </p>
              </div>

              <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-134" data-mp="2igy64y0fy7bt">
                {plan.features.map(f => <li key={f} className="flex items-center gap-2.5 text-sm text-white/80" data-id="element-135" data-mp="2dfsb2tjb67z4">
                    <CheckIcon className="h-4 w-4 shrink-0 text-iris-soft" strokeWidth={3} data-id="element-136" data-mp="3ttsa82abxtlb" />
                    {f}
                  </li>)}
              </ul>

              <div className="mt-7 w-full" data-id="element-137" data-mp="9c7ygel2wyn">
                <CTAButton size="md" className="w-full" href={CHECKOUT_URL} data-id="element-138" data-mp="cghltatikwp">
                  {plan.cta}
                </CTAButton>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}